const styles = theme => ({
  poster: {
    height: '100%',
    width: '100%',
    minHeight: '100vh',
    backgroundImage:
      'linear-gradient(to right top, #212a2a, #094153, #2d4f84, #864e98, #d6407d)',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '30%',
      minHeight: '30vh',
      },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/poster/styles.js